import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ProjectService} from '../project.service';
import {Terminal} from '../../model/terminal';
import {Questionnaire} from '../../model/questionnaire';
import {GenericModalComponent} from '../../modal/generic-modal.component';

@Component({

  selector: 'send-test-sms-dialog',
  styles: [
    `
      .modal-body {
        padding-left: 50px;
        padding-right: 50px;
        width: 100%;
        height: 150px;
      }

      .modal-footer{background-color: #ECE8E5;border-top:groove;}

      .modalBodyContainer{
        background-color:#ECE8E5;
      }
      .ContentSection {
        padding-left: 20px;
      }

      .sectionTitle {
        font-size: large;
        font-weight: bold;
      }

      .mainTable {
        margin-left: 20px;
      }

      .borderGray {
        border: 1px solid #ccc;
      }

      .collapse {
        border: 2px solid slategray;
      }

      #btnRemoveAccordion {
        float: right;
      }

      .borderRed {
        border: 1px solid red;
      }

      .mainTable {
        width: 100%;
      }

      .twitterTable {
        margin-left: 20px;
      }

      .downloadSection {
        margin-left: 20px;
      }

      .facebookTable {
        margin-left: 20px;
      }

      .btn.btn-success {
        color: #ffffff;
        background-color: #5CB85C;
        background-image: linear-gradient(to bottom, #5CB85C, #419641);
        border-color: #3E8F3E #3E8F3E #3E8F3E;
      }

      .btn.btn-success:hover {
        color: #ffffff;
        background-color: #419641;
        background-image: linear-gradient(to bottom, #419641, #419641);
        border-color: #3E8F3E #3E8F3E #3E8F3E;
      }
      .smsWindow{margin-top:-4px;height:40px;}


      .modal-dialog {
        margin: 50px auto auto;
        background-color: #0064FE;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }

      .modal-header {
        height:56px;
        background-image: url("../../../assets/images/headerBack.jpg");
        color:  #ECE8E5;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }

      .modal-content {
        border-top-right-radius: 18px;
        border-top-left-radius: 18px;
        background-color: #0064FE;
        padding-left: 3px;
        padding-right: 3px;
        padding-bottom: 3px;
      }

      .modal-title{margin-left:15px;}
      .closeX{color:azure;size:25px;}
      .btn-outline-danger {
        background-color: #d6462e;
        border-style: solid;
        border-color: white;
        border-width: 2px;
        padding: 0;
      }
      .closeIcon:hover{ width: 32px;background-image: url("../../../assets/images/closeBtnHovered.png");}

      .closeIcon{ width: 32px;background-image: url("../../../assets/images/closeBtn.png");}
      .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
      .btn-danger:hover{background-color: #FF2400;}
    `
  ],
  template: `
    <div class="modal" tabindex="-1" role="dialog" [style.display]="!hide ? 'inline' : 'none'" style="margin : 20px;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <!-- header-->
          <div class="modal-header">
            <h4><img class="smsWindow" src="../../assets/images/iPhoneSms.png"></h4>
            <h4 class="modal-title">Send Test SMS</h4>
            <h4 class="closeBtnH4"><button (click)="hideDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
              <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../../assets/images/closeBtn.png"></span>
            </button></h4>
          </div>
          <div class="modalBodyContainer">
          <div class="modal-body">
            <!-- Texts -->
            <p>Select your language for the preview</p>
            <div>
              <select [(ngModel)]="this.selectedLanguage">
                <option *ngFor="let lang of langArr" [value]="lang">
                  {{lang}}
                </option>
              </select>
            </div>
            <div class="row" style="margin-top:20px;margin-left:1px;">
              <form [formGroup]=this.smsForm>
                <div class="form-group">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1"><i class="fa fa-mobile" aria-hidden="true"></i></span>
                    </div>
                    <input type="text" formControlName="number" class="form-control emailControl" name="number"
                           pattern="\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})" required/>
                    <div style="padding-left:10px;" class="child-float-left input-validation "></div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- footer-->
          <div class="modal-footer ">
            <button type="button" (click)="this.onSmsTestSend(this.smsForm['controls'].number.value)" class="btn btn-primary clickable hand" id="submit"><span
              class="glyphicon glyphicon-floppy-disk"></span> {{'send' | translate}}
            </button>
          </div>
          </div>
        </div>
      </div>
    </div>
    <generic-info-modal [hide]="_hideInfoModal" (OkClick)="hideDialog()"></generic-info-modal>
  `
})

export class SendTestSmsComponent  implements OnInit {

  private smsForm:FormGroup;

  private _hideInfoModal =true;

  private selectedLanguage:string;

  // @Output() testSendSms: EventEmitter<any> = new EventEmitter();

  @Output() closeSmsTest: EventEmitter<any> = new EventEmitter();

  @Input('terminal') terminal:Terminal;
  @Input('questionnaire') questionnaire:Questionnaire;
  @Input('langArr')  langArr:string[];
  @Input() hide = true;

  @ViewChild (GenericModalComponent) genericModal: GenericModalComponent;

  constructor(private _projectService: ProjectService, private _formBuilder:FormBuilder) {

  }

  ngOnInit(): void {
    this.smsForm = this._formBuilder.group({
      number: ['', Validators.minLength(10)]
  });
  }

  /* onSendTestClick() {
    this.testSendSms.emit(this.smsForm['controls'].number.value);
  }*/

  hideDialog() {
    if(!this._hideInfoModal) {
      this._hideInfoModal = true;
    }
    this.closeSmsTest.emit();
  }


  public onSmsTestSend(number:string) {
    if(this.selectedLanguage==null || this.selectedLanguage==='') {
      this.genericModal.defineModal('Please select a language before pushing an SMS.','SMS Test',250);
      this._hideInfoModal = false;
      return;
    }
    this._projectService.sendSMS(this.questionnaire.projectId, this.questionnaire.id,this.terminal.id,this.terminal.type==='Android'?2:1,number,null,this.selectedLanguage).subscribe(
        (msg) => {
          if(Number(msg.valueOf()) === 100) {
            this.genericModal.defineModal('Test SMS sent successfully !','Terminal Node',200);
          } else if(Number(msg.valueOf()) === 102) {
            this.genericModal.defineModal('An error has occurred while sending SMS!','Terminal Node',102);
          }
          this._hideInfoModal = false;
        });
  }
}
